export default {
  circle: {
    state: {
      size: 500,
      windowWidth: 2000
    },
    mutations: {
      setCircleSize: (state: { size: number }, size: number) => {
        state.size = size;
      },

      setWindowWidth: (state: { windowWidth: number }, windowWidth: number) => {
        state.windowWidth = windowWidth;
      },
    },
    getters: {
      circleSize: (state: { size: number }) => {
        return state.size;
      },

      windowWidth: (state: { windowWidth: number }) => {
        return state.windowWidth;
      },
    },
  },
};
